import { Link } from "react-router-dom";
import { Store } from "lucide-react";
import { useTranslation } from "react-i18next";
import { cn } from "@/shared/lib/cn";
import { Button } from "@/shared/ui/core";

export interface SessionGreetingProps {
  /** El nombre de pila basta: "Hola, Anahí". */
  name: string;
  /**
   * La puerta al panel propio — TODO el que entra tiene uno (Anahí,
   * 27-ago: "todos inician como socios"): /socio, /mi-negocio o /admin.
   * La pone quien conoce la sesión; el rótulo depende del destino.
   */
  businessTo?: string | undefined;
  className?: string;
}

/**
 * La señal de "sí entraste": el saludo por nombre en la barra del
 * sitio. Es lo que reemplaza a los botones de acceso cuando hay sesión.
 *
 * SIN el botón "Salir" (Anahí, 27-ago): salir vive en el menú
 * desplegable — y en el panel, además, en el menú de la cuenta. Un
 * botón que cierra la sesión a un clic de distancia del logotipo era
 * más riesgo que atajo.
 */
export function SessionGreeting({ name, businessTo, className }: SessionGreetingProps) {
  const { t } = useTranslation();
  const firstName = name.trim().split(/\s+/)[0] ?? name;

  return (
    <div className={cn("items-center gap-2", className)}>
      <span className="max-w-[160px] truncate text-[13px] font-medium text-ds-ink">
        {t("Hola, {{name}}", { name: firstName })}
      </span>
      {businessTo && (
        <Button as={Link} to={businessTo} variant="secondary" size="sm" leftIcon={<Store />}>
          {businessTo === "/mi-negocio" ? t("Mi negocio") : t("Mi panel")}
        </Button>
      )}
    </div>
  );
}
